module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/_library.js
// module id = n1LN
// module chunks = 0